import { env } from "@/env";
import type NextImage from "next/image";

export const evaluateSrc = (src: Parameters<typeof NextImage>[0]["src"]) => {
  // If the src is already absolute (starts with http/https), return as is.

  if (
    typeof src === "string" &&
    src.startsWith("https://lh3.googleusercontent.com/")
  ) {
    return {
      type: "already-optimized" as const,
      src: src,
    };
  }

  if (
    typeof src === "string" &&
    (src.startsWith("http://") || src.startsWith("https://"))
  ) {
    return {
      type: "remote" as const,
      src: src,
    };
  }

  return {
    type: "local" as const,
    src: src,
  };
};

export function cloudflareLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number | `${number}`;
  quality?: number | `${number}`;
}) {
  if (env.NODE_ENV === "development") {
    return src;
  }
  const params = [`width=${width}`];
  if (quality) {
    params.push(`quality=${quality}`);
  }
  const paramsString = params.join(",");
  return `https://images.borderless.so/cdn-cgi/image/${paramsString}/${src}`;
}
